import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
export function setQueryPersist(key, value) {
  return dispatch => dispatch({
    type: ActionTypes.SET_QUERY_PERSIST,
    key,
    value
  });
}
export function removeQueryPersistByRegex(regex, modifier) {
  return dispatch => dispatch({
    type: ActionTypes.REMOVE_QUERY_PERSIST_BY_REGEX,
    regex,
    modifier
  });
}
export function removeQueryPersist(key) {
  return dispatch => dispatch({
    type: ActionTypes.REMOVE_QUERY_PERSIST,
    key
  });
}